var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox-wrapper",class:{ disabled: _vm.disabled }},[_c('svgicon',{class:_vm.state,attrs:{"name":_vm.state},on:{"click":function($event){return _vm.updateValue(!_vm.value)}}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }